module.exports = __webpack_public_path__ + "static/media/1012013.9b706cbb.png";